module.exports = __webpack_public_path__ + "static/img/no_news.6be09298.svg";